import * as React from 'react'
import { useState, useEffect } from 'react'
import './Slideshow.scss'
import { EditModeWrapper } from './EditModeWrapper'
import { ContentLoader } from './ContentLoader'
import { getValidColor, resolveStyleVariables } from '../../utils/themeUtil'
import { useLocation } from 'react-router-dom'
import { TableFred } from '../vis/TableFred'

export const Slideshow = (props) => {
    const item = props.item // dcard
    const [selIndex, setSelIndex] = useState(0)
    const location = useLocation()

    if (!item) return null

    let button_icons = item.data?.buttonIcons || []
    let button_labels = item.data?.buttonLabels || []
    let dcards = item.contents
    const position = item.data?.position || 'top'
    const buttonStyle = item.data?.buttonStyle || 'blue-buttons'

    if (button_icons?.length == null) {
        button_icons.push('fab fa-earlybirds')
    }

    if (button_labels?.length == null) {
        button_labels.push('new card')
    }

    const background_color = getValidColor(item.data?.backgroundColor || '--background-color')
    const stylesFromCard = resolveStyleVariables(item?.data?.style || {})

    const style = {
        ...stylesFromCard,
    }

    const classes = ['slideshow']
    if (!item.data?.wide) {
        classes.push('page-width')
    }

    const card = item.contents?.[selIndex]

    useEffect(() => {
        if (!card) {
            props.setLayoutReady?.(true)
        }
    }, [item])

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPress)

        return () => {
            document.removeEventListener('keydown', handleKeyPress)
        }
    }, [])

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search)
        const tabLabel = queryParams.get('ss_tab') // Get the 'tab' value as a string
        // console.log('tabLabel', tabLabel);
        // console.log('item.data.buttonLabels', item.data.buttonLabels);
        if (tabLabel && item.data?.buttonLabels) {
            const tabIndex = item.data.buttonLabels.findIndex(label => label.toLowerCase() === tabLabel.toLowerCase())
            if (tabIndex !== -1) {
                setSelIndex(tabIndex) // Set the index if a match is found
            }
        }
    }, [location, item.data?.buttonLabels])


    const setLayoutReady = (val) => {
        props.setLayoutReady?.(val)
    }

    const handleKeyPress = (event) => { }

    const showCard = (card_index) => {
        setSelIndex(card_index)
    }

    return (
        <EditModeWrapper
            className='has-children'
            item={item}
            edit={props.edit}
            restoredItem={props?.restoredItem}
            reloadItem={props.reloadItem}
            reloadParent={props.reloadParentItem}
            reloadParentItem={props.reloadParentItem}
            pageLevel={props.pageLevel}
        >
            <div className={classes.join(' ')} style={{ display: 'flex', flexDirection: 'column', ...style }}>
                {!item.contents ? 'add dcard(s) to slideshow' : null}
                {position == 'top' ? (
                    <div
                        className={buttonStyle === 'tabs' ? 'tab-container' : 'bar margintop'}
                        style={background_color ? { backgroundColor: background_color } : null}
                    >
                        {item.contents &&
                            item.contents.map((itm, index) => (
                                buttonStyle === 'tabs' ? (
                                    <div
                                        key={index}
                                        className={`tabs ${selIndex === index ? 'active' : ''}`}
                                        onClick={() => showCard(index)}
                                    >
                                        {button_labels[index]}
                                    </div>
                                ) : (
                                    <div
                                        key={index}
                                        className={`${buttonStyle} ${selIndex === index ? 'active' : ''}`}
                                        onClick={() => showCard(index)}
                                    >
                                        <i className={`icon ${button_icons[index]}`} />
                                        {button_labels[index]}
                                    </div>
                                )
                            ))}
                    </div>
                ) : null}

                {card ? (
                    <ContentLoader
                        id={card.id}
                        pageLevel={props.pageLevel}
                        restoredItem={card?.deleted}
                        reloadParentItem={props.reloadItem}
                        edit={props.edit}
                        restore={props.restore}
                        instanceContext={props.instanceContext}
                        setLayoutReady={setLayoutReady}
                        classes={['animate_card']}
                    />
                ) : null}

                {position == 'bottom' ? (
                    <div
                        className={buttonStyle === 'tabs' ? 'tab-container' : 'bar marginbottom'}
                        style={background_color ? { backgroundColor: background_color } : null}
                    >
                        {item.contents &&
                            item.contents.map((itm, index) => (
                                buttonStyle === 'tabs' ? (
                                    <div
                                        key={index}
                                        className={`tabs ${selIndex === index ? 'active' : ''}`}
                                        onClick={() => showCard(index)}
                                    >
                                        {button_labels[index]}
                                    </div>
                                ) : (
                                    <div
                                        key={index}
                                        className={`${buttonStyle} ${selIndex === index ? 'active' : ''}`}
                                        onClick={() => showCard(index)}
                                    >
                                        <i className={`icon ${button_icons[index]}`} />
                                        {button_labels[index]}
                                    </div>
                                )
                            ))}
                    </div>
                ) : null}
            </div>
        </EditModeWrapper>
    )
}
